// ** React Imports
import { useRef, useState } from 'react';

// ** Custom Components
import Wizard from '@components/wizard';

// ** Steps
import EpisodeDetails from './components/EpisodeDetails';
import ContentCreator from './components/ContentCreator';
import FrasesCreator from './components/FrasesCreator';
import { CreateEpisode, UpdateEpisode } from '../../../../graphql/Mutation';
import { useMutation } from '@apollo/client';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const WizardHorizontal = ({
  defaultValues,
  editMode = false,
  episodeId = ''
}) => {
  const [data, setData] = useState(defaultValues);
  const [createEpisode] = useMutation(CreateEpisode);
  const [updateEpisode] = useMutation(UpdateEpisode);
  // ** Ref
  const ref = useRef(null);

  // ** State
  const [stepper, setStepper] = useState(null);

  const handleState = async (_data, done) => {
    const dataFormated = {
      ...data,
      ..._data,
      status: String(_data.status || data.status) === 'true'
    };
    setData(() => dataFormated);
    try {
      if (done) {
        if (!editMode) {          
          await createEpisode({
            variables: {
              createEpisodeInput: dataFormated
            },
            refetchQueries: 'all'
          });
        } else {
          await updateEpisode({
            variables: {
              updateEpisodeInput: {
                _id: episodeId,
                data: dataFormated
              }
            },
            refetchQueries: 'all'
          });
        }
        window.location.href = '/roads/episodes/list';
      }
    } catch (e) {}
  };

  const steps = [
    {
      id: 'episode-details',
      title: 'Detalles del Episodio',
      subtitle: 'Datos básicos del episodio.',
      content: (
        <EpisodeDetails
          stepper={stepper}
          handleOnSubmit={handleState}
          defaultValues={data}
        />
      )
    },
    {
      id: 'content-creator',
      title: 'Crear Contenido',
      subtitle: 'Crea el episodio',
      content: (
        <ContentCreator
          stepper={stepper}
          handleOnSubmit={handleState}
          defaultValues={data}
        />
      )
    },
    {
      id: 'frase-creator',
      title: 'Crear Frases',
      subtitle: 'Frases para compartir',
      content: (
        <FrasesCreator
          stepper={stepper}
          handleOnSubmit={handleState}
          defaultValues={data}
          editMode={editMode}
        />
      )
    }
  ];

  return (
    <div className="horizontal-wizard">
      <Wizard instance={(el) => setStepper(el)} ref={ref} steps={steps} />
    </div>
  );
};

export default WizardHorizontal;
